export class HashTools {
  /**
   * Produces a deterministic, non-reversible 16-character hex hash of the input string.
   * Suitable for anonymizing identifiers (e.g. user IDs, account names) before
   * sending them to third-party analytics services.
   *
   * Uses a cyrb53-style dual-accumulator hash — not cryptographic, but sufficient
   * for preventing identification from analytics data.
   */
  public static anonymize(value: string): string {
    let h1 = 0xdeadbeef;
    let h2 = 0x41c6ce57;
    for (let i = 0; i < value.length; i++) {
      const ch = value.charCodeAt(i);
      h1 = Math.imul(h1 ^ ch, 2654435761);
      h2 = Math.imul(h2 ^ ch, 1597334677);
    }
    h1 = Math.imul(h1 ^ (h1 >>> 16), 2246822507);
    h1 ^= Math.imul(h2 ^ (h2 >>> 13), 3266489909);
    h2 = Math.imul(h2 ^ (h2 >>> 16), 2246822507);
    h2 ^= Math.imul(h1 ^ (h1 >>> 13), 3266489909);
    return (h2 >>> 0).toString(16).padStart(8, '0') + (h1 >>> 0).toString(16).padStart(8, '0');
  }
}
